module.exports = __webpack_public_path__ + "img/construction_12_steps_splash.e48c7934.jpg";